<template>
    <div class="box-wrap active-box-wrap" :style="boxWrapStyleObj">
        <span class="border-left-top"></span>
        <span class="border-left-bottom"></span>
        <span class="border-right-top"></span>
        <span class="border-right-bottom"></span>
        <div class="statis-title bg1" style="display: flex;justify-content: center;" :ref="`${activeType}_statisTitle`">
            <span>{{ title }}</span><span class="split-line">|</span>
            <div class="active-statis">
                <Select v-model="timeSolt" ref="timeIntervalSelectRef" placeholder="全部时段"
                    @on-change="changeTimeSolt($event)">
                    <Option value="0">全部时段</Option>
                    <Option value="1">近一周</Option>
                    <Option value="2">近一月</Option>
                </Select>
            </div>
            <span class="active-box-more-txt click-element" @click="lookMoreData">
                更多
                <i></i>
            </span>
        </div>
        <ul class="active-static-tab" :ref="`${activeType}_staticTabRef`">
            <template v-for="item in tabList">
                <li class="active-static-tab-item click-element"
                    :class="item.code == tabCode ? 'active-static-tab-item-selected' : ''" @click="changeModule(item.code)"
                    :title="item.title">{{ item.title }}
                </li>
            </template>
        </ul>
        <Row :gutter="12" style="margin-bottom: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <pie-charts :chartsTitle="''" :showTitle=false :isShowMore=false :isShowTitle="false" :isClickCharts=false
                :pieChartsName="''" :chartsId="'period_active-statics'" :height="'167px'" :pieRadiusArr="pieRadiusArr"
                :colorArr="pieColorArr" ref="periodActiveStaticsRef">
            </pie-charts>
            </Col>
        </Row>
    </div>
</template>

<script>
import {
    findSummaryByPhase,
    findSchoolYears
} from "../../../service/bigDataApi.js";
const PieCharts = () => import("../../../components/charts/PieCharts.vue");//环形图
export default {
    name: "active-period-statis",
    data() {
        return {
            screenWidth: 0, //屏幕宽度
            boxWrapStyleObj: {
                height: ''
            },
            contentStyleObj: {
                height: ''
            },
            styleObj: {
                width: '100%',
                height: '100%'
            },
            countWeight: 400,
            tabList: [
                {
                    code: 'resTab',
                    title: '上传资源数'
                },
                {
                    code: 'microTab',
                    title: '上传微课数'
                },
                {
                    code: 'hwTab',
                    title: '布置作业数'
                },
                {
                    code: 'studyTab',
                    title: '探究学习'
                }
            ],
            pieRadiusArr: ['50%', '70%'],
            timeSolt: '',
            startDate: '',
            endDate: '',
            tabCode: 'resTab',
            activeGradeList: [],
            activeClassList: [],
            activeTeacherList: [],
            curActiveGradeData: {},//当前年级活跃下的统计数据
            gradeList: [],
            subjectList: [],
            gradeId: "",
            subjectId: '',
            title: '学段活跃情况',
            activeType: 'phase',
            pieColorArr: ['#ffc23e', '#00ffe8', '#1bccff']
        }
    },
    components: {
        PieCharts
    },
    props: {
        screenHeight: Number,
        titleHeight: Number,
        curYear:String
    },
    watch: {
        'screenHeight': 'initBoxHeight',
        'titleHeight': 'initBoxHeight'
    },
    methods: {
        /**
         * 初始化box高度
         */
        initBoxHeight() {
            let titleRef = this.activeType + '_statisTitle';
            let tabRef = this.activeType + '_staticTabRef';
            let winHeight = window.innerHeight;
            if (winHeight < 900) {
                winHeight = 938;
            }
            let boxWrapHeight = (winHeight - 128 - 10 - 30) / 3;
            let contentHeight = boxWrapHeight - this.$refs[titleRef].offsetHeight - this.$refs[tabRef].offsetHeight - 20;
            this.boxWrapStyleObj.height = boxWrapHeight + 'px';
            this.contentStyleObj.height = contentHeight + 'px';
        },
        /**
         * 根据不同的情况请求数据
         */
        handleSearch() {
            let order = "";
            if (this.tabCode == 'hwTab') {
                order = 'tea_hw_num' + ' desc';
            } else if (this.tabCode == 'microTab') {
                order = 'cw_upload_num' + ' desc';
            } else if (this.tabCode == 'resTab') {
                order = 'rs_upload_num' + ' desc';
            } else if (this.tabCode == 'studyTab') {
                order = 'inquiry_num' + ' desc';
            }
            this.getSummaryByPhase(order)
        },
        /**
         * @name 获取当前学年
         */
        async getCurrentSchoolYear() {
            // var date = new Date();
            // let newYear = date.getFullYear();
            // let lastYear = newYear-1;
            // return lastYear + '-' + newYear + '学年';
            let curYear = '';
            const res = await findSchoolYears();
            if (res.length > 0) {
                curYear = res[0];
            }
            return curYear;
        },
        /**
         * 获取学段
         */
        async getSummaryByPhase(order) {
            let _this = this;
            let param = {
                agentId: this.$route.query.agentId||this.$store.getters.agentId,
                order: order,
                schoolYear: await this.getCurrentSchoolYear()
            };
            if (_this.startDate && _this.endDate) {
                param.sTime = _this.$utils.formatDate(new Date(_this.startDate));
                param.eTime = _this.$utils.formatDate(new Date(_this.endDate));
            }
            await findSummaryByPhase(param)
                .then(function (data) {
                    let resultData = data;
                    //处理数据
                    _this.handleTabData(resultData);
                })
                .catch(function (error) {
                    _this.$Message.error(error.message);
                });
        },
        /**
         * 处理数据
         */
        handleTabData(data) {
            let _this = this;
            let nameArr = [];
            let numArr = [];
            for (let i = 0; i < data.length; i++) {
                let obj = {};
                data[i].phaseName = _this.getPhase(data[i].phase);
                obj.name = data[i].phaseName;
                if (this.tabCode == 'hwTab') {
                    obj.value = data[i].tea_hw_num;
                } else if (this.tabCode == 'microTab') {
                    obj.value = data[i].cw_upload_num;
                } else if (this.tabCode == 'resTab') {
                    obj.value = data[i].rs_upload_num;
                } else if (this.tabCode == 'studyTab') {
                    obj.value = data[i].inquiry_num;
                }
                nameArr.push(obj.phaseName);
                numArr.push(obj);
            }
            this.$nextTick(() => {
                setTimeout(function () {
                    //渲染图表
                    _this.$refs.periodActiveStaticsRef.initDataSource(data, nameArr, numArr);
                }, 200);
            });
        },
        /**
         * @name 通过phase将学段显示成中文
         * @param {*} code 
         */
        getPhase(code) {
            let phase = code;
            phase = phase.replace("0", "幼儿园");
            phase = phase.replace("1", "小学");
            phase = phase.replace("2", "初中");
            phase = phase.replace("3", "高中");
            phase = phase.replace("4", "中职");
            phase = phase.replace("5", "高职");
            phase = phase.replace("6", "大学");
            phase = phase.replace("7", "特殊学校");
            phase = phase.replace("8", "其他");
            return phase;
        },
        /**
         * 选中当前排行榜已选中项
         */
        changeGrade(index) {
            this.curActiveGradeData = this.activeGradeList[index];
        },
        /**
         * 选择时间段
         */
        changeTimeSolt(type) {
            this.timeSolt = type;
            let todayStr = this.$utils.getNDayStr(1);
            this.endDate = todayStr + ' 23:59:59';
            //获取近一周时间
            if (this.timeSolt === '1') {
                this.startDate = this.$utils.getYestodaySevenDayStr(1) + ' 00:00:00';
            } else if (this.timeSolt === '2') {
                //获取近一月时间
                this.startDate = this.$utils.getPreMonthDay(todayStr, 1) + ' 00:00:00';
            } else {
                this.startDate = '';
                this.endDate = '';
            }
            this.handleSearch();
        },
        /**
         * 根据type和当前tab获取相应数据
         */
        changeModule(val) {
            this.tabCode = val;
            this.timeSolt = "";
            this.startDate = '';
            this.endDate = '';
            this.$refs.timeIntervalSelectRef.clearSingleSelect();
            if (this.$refs.activeTypeRef) {
                this.$refs.activeTypeRef.initParams();
            }
            this.handleSearch();
        },
        /**
         * 更新当前选中的学科id或年级id
         */
        updateSelectedData(subjectId, gradeId) {
            this.subjectId = subjectId;
            this.gradeId = gradeId;
            this.handleSearch();
        },
        /**
         * 查看更多数据信息
         */
        lookMoreData() {
            const agentId = this.$route.query.agentId || this.$store.getters.agentId;
            const agentName = this.$route.query.agentName || this.$store.getters.agentName;
            const token = this.$route.query.token || this.$store.getters.token;
            let routeData = this.$router.resolve({
                name: "regionstatisdetails",
                query: {
                    token: token,
                    agentId: agentId,
                    agentName: agentName,
                    activeType: this.activeType,
                    tabCode: this.tabCode,
                    activeTypeName: '学段活跃情况'
                }
            });
            window.open(routeData.href, "_blank");
        }
    },
    mounted() {
        this.changeModule('resTab')
    }
}
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";
@import "../../../style/layout";

.bg1 {
    background-image: url("../../../assets/images/databoard/title-bg3.png");
}

.active-static-tab-item {
    background-image: url("../../../assets/images/databoard/icon_tab_normal.png");
}

.active-static-tab-item-selected {
    background-image: url("../../../assets/images/databoard/icon_tab_hover.png");
}

.active-box-more-txt i {
    background-image: url(../../../assets/images/databoard/active-icon.png);
    background-position: -299px 90px;
}

.active-static-icon-arrow-down {
    background-image: url(../../../assets/images/databoard/active-icon.png);
    background-position: -224px 90px;
}

.chart-error {
    margin-top: 0 !important;
    background: transparent !important;
    color: #0efcff !important;
}
</style>

<style lang="scss">
.chart-error {
    margin-top: 0 !important;
    background: transparent !important;
    color: #0efcff !important;
}

.active-statis {
    .ivu-select-selection {
        box-shadow: transparent !important;
        background-color: transparent !important;
        border: transparent !important;
    }

    .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
    .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        font-size: 16px !important;
        color: #0efcff !important;
    }

    .ivu-select-arrow {
        color: #0efcff !important;
    }

    .ivu-select-dropdown {
        max-height: 100px;
        background: rgba(10, 18, 39, 0.97);
        box-shadow: inset 0px 0px 10px 4px rgba(14, 252, 255, 0.15) !important;
        border-radius: 5px
    }

    .ivu-select-item {
        color: #0efcff !important;
        text-align: center;
    }

    .ivu-select-item:hover {
        background: #0efcff !important;
        color: #0a1227 !important;
    }

    .ivu-select-item-focus {
        background: #0efcff !important;
        color: #0a1227 !important;
    }
}
</style>
